import { Box, Progress, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { resetHeader, searchAutocompleteList, searchReset, setAutocompleteVisibility, setHeaderAdvancedSearchParams, setHeaderText, setSelectedMenuItem } from "../../redux/actions/action";
import { loadLiveCourses } from "../../redux/api/apiCalls";
import AllLiveSessions from "./AllLiveSessions";

export default function LiveSessions() {
    const { liveCoursesData, isLoading /*, liveCoursesError */ } = useSelector(state => state.liveCoursesState)
    const [visibleData, setVisibleData] = useState([])
    const finalSearch = useSelector(state => state.searchState.finalSearch)
    const advancedSearch = useSelector(state => state.advancedSearchState)
    const dispatch = useDispatch()


    useEffect(() => {
        dispatch(setHeaderText('Live Sessions'))
        dispatch(setSelectedMenuItem(3))
        dispatch(loadLiveCourses())
        dispatch(setHeaderAdvancedSearchParams(["Trainer", "Duration"]))
        return () => {
            dispatch(searchReset())
            dispatch(resetHeader())
        }
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (advancedSearch.length) {
            let filteredResult = []
            advancedSearch.forEach(param => {
                if (param[1].length > 0) {
                    if (param[0] === "Trainer") {
                        filteredResult = liveCoursesData.filter(liveCourse => liveCourse.host_name.toLowerCase().indexOf(param[1].toLowerCase()) !== -1)
                    }
                    else {
                        if (filteredResult.length) {
                            filteredResult = filteredResult.filter(liveCourse => (((Date.parse(liveCourse.end) - Date.parse(liveCourse.start)) / 60000)) === Number(param[1]))
                        }
                        else {
                            filteredResult = liveCoursesData.filter(liveCourse => (((Date.parse(liveCourse.end) - Date.parse(liveCourse.start)) / 60000)) === Number(param[1]))
                        }
                    }
                }
            })
            if (filteredResult.length) {
                setVisibleData(filteredResult)
            }
        }
        // eslint-disable-next-line
    }, [advancedSearch])

    useEffect(() => {
        if (liveCoursesData.length > 0) {
           setVisibleData(liveCoursesData.map(course => course))
            dispatch(searchAutocompleteList(liveCoursesData.map(course => course.title)))
        }
        // eslint-disable-next-line
    }, [liveCoursesData])

    useEffect(() => {
        if (finalSearch && finalSearch.length) {
            setVisibleData(liveCoursesData.filter(course => finalSearch.includes(course.title)))
        }
        // eslint-disable-next-line
    }, [finalSearch])

    return (
        <Box
            px='1rem'
            w='95%'
            minH='90vh'
            onClick={(e) => {
                e.stopPropagation()
                dispatch(setAutocompleteVisibility(false))
            }}
        >
            <Text
                fontSize={['20px', '25px', '30px', '40px']}
                d={['none', 'none', 'none', 'none', 'flex']}
                fontWeight='900'
                style={{ fontFamily: 'Mulish, sans-serif' }}
                py='2rem'
            >
                Live Sessions
            </Text>
            {
                isLoading ? <Progress isIndeterminate size='xs' width='100%' /> :
                    <AllLiveSessions sessions={visibleData} />
            }
            {/* {
                !isLoading && liveCoursesError && <Box>{liveCoursesError}</Box>
            } */}
        </Box>
    )
}